import React, { useLayoutEffect } from "react";
import { StyleSheet, View, Image } from "react-native";
import { colors } from "src/assets";
import { Button } from "src/components";
import { localizationStrings } from "./constants";
import { useNavigation, useRoute } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export type AuthLandingScreenNavigationParam = {
  redirect?: string;
};

export const AuthLandingScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"Auth">["navigation"]>();
  const route = useRoute<RootStackScreenProps<"Auth">["route"]>();
  useLayoutEffect(() => {
    navigation.setOptions({ title: "認証" });
  });
  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image source={require("./assets/logo.png")} />
      </View>

      <View style={styles.buttonsContainer}>
        <Button
          title={localizationStrings.btnSignUp}
          icon={"sign-up"}
          onPress={() => navigation.navigate("SignUp")}
        />
        <Button
          title={localizationStrings.btnSignIn}
          variant={"secondary"}
          onPress={() =>
            navigation.navigate("SignIn", { redirect: route.params.redirect })
          }
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  logoContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonsContainer: {
    flexDirection: "column",
    paddingHorizontal: 16,
  },
});
